export default __webpack_public_path__ + "static/media/metamask.fac5fa65.svg";